import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class proposedRuleHistoryApi<ProposedRuleHistory> extends BaseAPI {
  // constructor() {}

  public getAllProposedRuleHistory: () => Promise<ProposedRuleHistory[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRuleHistory`)).data.output;
  };

  public getProposedRuleHistoryById: (id: number) => Promise<ProposedRuleHistory> = async (
    id: number
  ) => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRuleHistory/${id}`)).data.output;
  };

  public getProposedRuleHistoryByDraftId: (id: number) => Promise<ProposedRuleHistory[]> = async (
    id: number
  ) => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRuleHistory/GetByDraftId/${id}`)).data
      .output;
  };
}

export const proposedRuleHistoryAPI = new proposedRuleHistoryApi();
